import * as z from "zod/v4";

const CompetitorSchema_ = z.object({
  name: z.string(),
  website: z.string(),
  competitionScore: z.number(),
  competitiveCategory: z.string(),
});
export const CompetitorSchema: z.ZodType<CompetitorSchema> = CompetitorSchema_;
export interface CompetitorSchema extends z.infer<typeof CompetitorSchema_> {}

const BrandIdentityGuideSchema_ = z.object({
  id: z.string(),
  companyName: z.string(),
  website: z.string(),
  headquarters: z.string(),
  foundedYear: z.string(),
  industry: z.string(),
  companyDescription: z.string(),
  brandVoice: z.string(),
  missionStatement: z.string(),
  contentStrategy: z.string(),
  marketPosition: z.string(),
  competitiveDifferentiation: z.string(),
  coreValues: z.array(z.string()),
  targetAudience: z.string(),
  brandKeywords: z.string(),
  competitors: z.array(CompetitorSchema),
});

export const BrandIdentityGuideSchema: z.ZodType<BrandIdentityGuideSchema> =
  BrandIdentityGuideSchema_;
export interface BrandIdentityGuideSchema
  extends z.infer<typeof BrandIdentityGuideSchema_> {}

export const getBrandIdentityGuide = {
  name: "getBrandIdentityGuide" as const,
  input: z.object({}),
  output: BrandIdentityGuideSchema.nullable(),
};
